import { useState } from 'react';
import './SHEventETicket.css';
import { useLanguage } from '../../../../../LanguageProvider';

export default function SHEventETicket({ coverImage, ticket, event, style, clickable = true }) {
    const [isQrOpen, setIsQrOpen] = useState(false);
    const { language, getTranslation } = useLanguage();

    const formatDate = (ts, opts = { day: "numeric", month: "long", weekday: "long" }) => {
        if (!ts) return "-";
        const n = Number(ts);
        if (!Number.isFinite(n)) return "-";
        return new Intl.DateTimeFormat(language, {
            timeZone: "Europe/Istanbul",
            ...opts
        }).format(new Date(n * 1000));
    };

    const formatTime = (ts) => {
        if (!ts) return "-";
        const n = Number(ts);
        if (!Number.isFinite(n)) return "-";
        return new Intl.DateTimeFormat(language, {
            timeZone: "Europe/Istanbul",
            hour: "2-digit",
            minute: "2-digit"
        }).format(new Date(n * 1000));
    };

    const formatPrice = (paid, currency) => {
        if (paid == null || paid === "") return "-";
        const num = Number(paid);
        const amount = Number.isFinite(num) ? num.toLocaleString(language) : String(paid);
        return currency ? `${amount} ${currency}` : amount;
    };

    return (
        <>
            <div className='sh-event-ticket-main' style={style}>
                <div className='sh-event-ticket-image-side'>
                    <img src={coverImage || event?.cover} width='auto' height='250px' alt='Event cover' />
                </div>

                <div className='sh-event-ticket-left-side'>
                    <div className='sh-event-ticket-info-box'>
                        <div className='sh-event-ticket-column'>
                            <span className='sh-event-ticket-subtitle'>{getTranslation("event")}:</span>
                            <span className='sh-event-ticket-info'>
                                {event?.title || "-"}
                            </span>

                            <span className='sh-event-ticket-subtitle'>{getTranslation("timeRange")}:</span>
                            <span className='sh-event-ticket-info'>
                                {`${formatTime(event?.eventStartDateTime)} - ${formatTime(event?.eventEndDateTime)}`}
                            </span>

                            <span className='sh-event-ticket-subtitle'>{getTranslation("purchaseDate")}:</span>
                            <span className='sh-event-ticket-info'>
                                {formatDate(ticket?.paymentDateTime)}
                            </span>
                        </div>

                        <div className='sh-event-ticket-column'>
                            <span className='sh-event-ticket-subtitle'>{getTranslation("date")}:</span>
                            <span className='sh-event-ticket-info'>
                                {formatDate(event?.eventStartDateTime)}
                            </span>

                            <span className='sh-event-ticket-subtitle'>{getTranslation("eventLocation")}:</span>
                            <span className='sh-event-ticket-info'>
                                {event?.locationAddress || "-"}
                            </span>

                            <span className='sh-event-ticket-subtitle'>{getTranslation("ticketType")}:</span>
                            <span className='sh-event-ticket-info'>
                                {ticket?.title}
                            </span>
                        </div>
                    </div>
                </div>

                {clickable === true ?
                    <div className={`sh-event-ticket-right-side ${ticket?.isUsed === "1" ? "ticket-used-tilted" : ""}`}>
                        {ticket?.ticketQRCode && (
                            <div className='sh-event-ticket-qr' style={{ cursor: 'var(--pointer)' }} onClick={() => setIsQrOpen(true)}>
                                <img src={ticket.ticketQRCode} alt='QR Kod' />
                                {ticket?.isUsed === "1" && (
                                    <div className="used-watermark">USED</div>
                                )}
                            </div>
                        )}
                    </div>
                    :

                    <div className={`sh-event-ticket-right-side`}>
                        {ticket?.ticketQRCode && (
                            <div className='sh-event-ticket-qr'>
                                <img src={ticket.ticketQRCode} alt='QR Kod' />
                            </div>
                        )}
                    </div>
                }
            </div>

            {/* QR Modal */}
            {isQrOpen && (
                <div className='qr-modal-overlay' onClick={() => setIsQrOpen(false)}>
                    <div className='qr-modal-content' onClick={(e) => e.stopPropagation()}>
                        <img src={ticket.ticketQRCode} width={350} height={350} alt='QR Kod Büyütülmüş' />
                    </div>
                </div>
            )}
        </>
    );
}